import VideoSlideshowNullState from './VideoSlideshowNullState';

export default VideoSlideshowNullState;
